/* global require */

import {importAll} from '../util/webpack';

importAll(require.context(`.`, true, /^(?!.*__test__\/).*index\.(js|ts|tsx)$/));
